<mat-dialog-content class="place-content-center w-full h-full">
  <div class="h-1/6">
    <div class="text-xl">
      {{ title }}
    </div>
    <div class="text-sm text-accent-color-200">
      {{ 'raw-data.info.DUPLICATE_DATA' | transloco }}
    </div>
  </div>
  <div class="overflow-auto h-4/6">
    @if (dataSource$ | async; as dataSource) {
      <ng-container>
        <table mat-table [dataSource]="dataSource">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef>Select</th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox
                (click)="$event.stopPropagation()"
                (change)="onCheckboxChange(row.id)"
                [checked]="selectedCheckbox === row.id"
              >
              </mat-checkbox>
            </td>
          </ng-container>

          <ng-container matColumnDef="settlementPrice">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'raw-data.fields.SETTLEMENT_PRICE' | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.settlementPrice }}
            </td>
          </ng-container>
          <ng-container matColumnDef="openPrice">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'raw-data.fields.OPEN_PRICE' | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">{{ element.openPrice }}</td>
          </ng-container>
          <ng-container matColumnDef="highPrice">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'raw-data.fields.HIGH_PRICE' | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.highPrice }}
            </td>
          </ng-container>
          <ng-container matColumnDef="lowPrice">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'raw-data.fields.LOW_PRICE' | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.lowPrice }}
            </td>
          </ng-container>

          <ng-container matColumnDef="volume">
            <th mat-header-cell *matHeaderCellDef>
              {{ 'raw-data.fields.VOLUME' | transloco }}
            </th>
            <td mat-cell *matCellDef="let element">
              {{ element.volume }}
            </td>
          </ng-container>

          <tr
            mat-header-row
            *matHeaderRowDef="displayedColumns; sticky: true"
          ></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </ng-container>
    }
  </div>
  <div class="flex gap-6 justify-center place-items-end h-1/6">
    <cc-cancel-action-button
      [mat-dialog-close]="true"
    ></cc-cancel-action-button>
    <cc-delete-action-button
      displayText="{{ 'raw-data.action.DELETE_DUPLICATE_DATA' | transloco }}"
      (onClick)="deleteItems()"
      [disabled]="!selectedCheckbox"
    ></cc-delete-action-button>
  </div>
</mat-dialog-content>
